import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { Grid, MenuItem, Select, Typography, Divider } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { size } from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  bold: {
    fontWeight: 600,
  },
}));

export default function CustomizedInputs(props) {
  const { register, errors, defaultItem, ctl, watch, setValue } = props;
  const classes = useStyles();
  const [fecha_fin, setFecha_fin] = useState(ctl.infosol.fecha_fin);
  const options = [
    { idestatus: 9, label: "Activo" },
    { idestatus: 10, label: "Inactivo" },
  ];
  // const [value, setValue] = React.useState(options[0]);
  const [inputValue, setInputValue] = React.useState("");

  const handleChangePrioridad = (event, value) => {
    setValue("prioridad", value);
  };

  const handleChange = (event, value) => {
    setValue("responsable", value);
  };

 const suma_ma = ctl.infosolMalcance.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.nhoras_totales), 0);
 const suma_testeo_ma = ctl.infosolMalcance.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.hrs_testeo_ma), 0);
 const sumas = (ctl.infosol.nhoras_totales && (suma_ma != null) ? parseInt(ctl.infosol.nhoras_totales) + suma_ma : ctl.infosol.nhoras_totales );
 const resta = (sumas - ctl.nhoras_actuales[0].sumatoria_tareas   );
 const suma_revisiones_testeo_ma = ctl.infosolMalcance.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.revisiones_tester_ma), 0);

 const obtenerFechaFin = (event, value) => {
  for(let i = 0; i < size(ctl.infosolMalcance); i++){
    if ( new Date(ctl.infosolMalcance[i].fecha_fin_ma).getTime() > new Date(fecha_fin).getTime() ){
      setFecha_fin( ctl.infosolMalcance[i].fecha_fin_ma );
    }
  }
 };

 useEffect(() => {
    obtenerFechaFin();
  }, []);

  return (
    <Grid container className={classes.root} spacing={1}>
      <Grid item md={4} xs={4}>
        <Typography variant="caption" className={classes.bold}>
          TIPO:
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption">
         {ctl.infosol.ntipo_solicitud || "N/D"}
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption" className={classes.bold}>
        PRIORIDAD:
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption">
          {ctl.infosol.nprioridad || "N/D"}
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption" className={classes.bold}>
        SISTEMA:
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption">
          {ctl.infosol.proyectos || "N/D"}
        </Typography>
      </Grid>
      {/* <Grid item md={4} xs={4}>
        <Typography variant="caption" className={classes.bold}>
        TÍTULO:
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption">
          {ctl.infosol.titulo || "N/D"}
        </Typography>
      </Grid> */}
      <Grid item md={4} xs={4}>
        <Typography variant="caption" className={classes.bold}>
        SOLICITANTE:
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption">
          {ctl.infosol.solicitante || "N/D"}
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption" className={classes.bold}>
        SOLICITUD:
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption">
          {ctl.infosol.problematica || "N/D"}
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption" className={classes.bold}>
        FECHAS:
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption" >
          {ctl.infosol.fecha_inicio ? ctl.infosol.fecha_inicio + " AL " + fecha_fin : "N/D"}
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption" className={classes.bold}>
        NO. DE HORAS PROPUESTA:
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption">
          { sumas|| "N/D"}
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption" className={classes.bold}>
        NO. DE HORAS ASIGNADAS:
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption">
          {ctl.nhoras_actuales[0] ? ctl.nhoras_actuales[0].sumatoria_tareas : "N/D" }
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption" className={classes.bold}>
        NO. DE HORAS POR ASIGNAR:
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption">
          {resta ? (resta < 0 ? 0 : resta) : 0 }
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption" className={classes.bold}>
        NO. DE HORAS TESTEO:
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption">
          { ( parseInt(ctl.infosol.hrs_testeo)+parseInt(suma_testeo_ma)) || "N/D"}
        </Typography>
      </Grid>
      <Grid item md={8} xs={8}>
        <Typography variant="caption" className={classes.bold}>
          NO. REVISIONES TESTER:
        </Typography>
      </Grid>
      <Grid item md={4} xs={4}>
        <Typography variant="caption">
          { ( parseInt(ctl.infosol.revisiones_tester)+parseInt(suma_revisiones_testeo_ma)) || "N/D"}
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="caption" className={classes.bold}>
        CORREO DE CONTACTO:
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="caption">
          {ctl.infosol.correo || "N/D"}
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="caption" className={classes.bold}>
        DESCRIPCIÓN DE LA SOLICITUD:
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography variant="caption">
        {ctl.infosol.desc_solicitud || "N/D"}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  );
}
